import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getStatesApi } from "src/network/api";

const StateSelector = ({ currentState, countryId, onSelectStateCallback }) => {
  const [states, setStates] = useState([]);

  const fetchStates = async () => {
    try {
      if (!countryId) return;
      const response = await getStatesApi(countryId);
      setStates(response.data.data);
    } catch (e) {
      console.log("Fetch Error:", e);
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  useEffect(() => {
    fetchStates();
  }, [countryId]);

  return (
    <div>
      <select
        onChange={(e) => onSelectStateCallback(e.target.value)}
        value={currentState}
        id="state-select"
        disabled={!countryId}
      >
        <option value="">-- Select State --</option>
        {states &&
          states.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
      </select>
    </div>
  );
};

export default StateSelector;
